/*
 * @Author: renjie.yin
 * @Date: 2023-01-13 14:05:50
 * @LastEditors: renjie.yin
 * @LastEditTime: 2023-01-13 14:11:27
 * @Description:
 */
const DEFAULT_FILTER_OPTIONS = [
  {
    title: '包含',
    key: 'contain',
    filter: value => data => {
      if (data == null) {
        return false
      }
      if (typeof data === 'number') {
        data = data + ''
      }
      return data.includes(value[0])
    }
  },
  {
    title: '不包含',
    key: 'notContain',
    filter: value => data => {
      if (data == null) {
        return true
      }
      if (typeof data === 'number') {
        data = data + ''
      }
      return !data.includes(value[0])
    }
  },
  {
    title: '等于',
    key: 'equal',
    filter: value => data => {
      return value[0] === data
    }
  },
  {
    title: '不等于',
    key: 'notEqual',
    filter: value => data => {
      return value[0] !== data
    }
  },
  {
    title: '为空',
    key: 'isNull',
    filter: () => data => {
      return !data
    }
  },
  {
    title: '不为空',
    key: 'notIsNull',
    filter: () => data => {
      return !!data
    }
  }
]

export { DEFAULT_FILTER_OPTIONS }
